/**
 * Canonical debug namespaces.
 *
 * Every `createDebug()` call must use one of these so the set of things that can
 * be switched on stays discoverable (and greppable) instead of drifting into
 * ad-hoc strings. Namespaces are hierarchical, separated by `:` — a spec of
 * `listing:*` enables every namespace under `listing`.
 */
export const DEBUG_NAMESPACES = {
  /** Currency symbols/rates merging — the client-side currency list. */
  currency: 'currency',
  /** Form validation outcomes (react-hook-form + zod resolver). */
  form: 'form',
  /** Listing create/update form: submit payloads, validation, redirects. */
  listingForm: 'listing:form',
  /** Outgoing HTTP requests made through `@/libs/request`. */
  request: 'request',
} as const;

export type DebugNamespace = (typeof DEBUG_NAMESPACES)[keyof typeof DEBUG_NAMESPACES];
